<div ngbDropdown class="dropdown d-inline-block">
    <a ngbDropdownToggle class="dropdown-toggle no-caret pl-2 pr-2" id="user-menu" data-bs-toggle="dropdown"
        aria-haspopup="true" aria-expanded="true">
        <i class="fa fa-check" style="color: green;font-size: 20px;" aria-hidden="true"  *ngIf="global.checkidleTime==true &&  global.checkidlePurchase==true && global.checkidleTransaction==true && global.checkidleCSG==true"
             title="Billing is in Idle"></i>
        <i class="fa fa-check" style="color: green;font-size: 20px;"  aria-hidden="true"  *ngIf="(global.checkProgressTimesheet==false && global.checkProgressPurchase!=true && global.checkProgressTransaction!=true && global.checkProgressCSG!=true) || (global.checkProgressTimesheet!=true && global.checkProgressPurchase==false && global.checkProgressTransaction!=true && global.checkProgressCSG!=true) || (global.checkProgressTimesheet!=true && global.checkProgressPurchase!=true && global.checkProgressTransaction==false && global.checkProgressCSG!=true) || (global.checkProgressCSG==false && global.checkProgressTimesheet!=true && global.checkProgressPurchase!=true && global.checkProgressTransaction!=true)"
            title="Billing process completed"></i>
        <i class="fa fa-spinner fa-spin" style="color:#502189;font-size: 20px;" *ngIf="global.checkProgressTimesheet==true || global.checkProgressPurchase==true || global.checkProgressTransaction==true || global.checkProgressCSG==true"
            aria-hidden="true" title="Billing is in-progress"></i>
    </a>
    <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right rounded-0 mt-3 p-0 box-shadow"
        aria-labelledby="user-menu">
        <div class="row mb-4 mt-4">
            <h4 style="font-weight: bold;;text-align:center;"><b>Billing Process</b></h4>
        </div>
        <div class="row mb-3 ms-3">
            <div class="col-lg-9">
                <h5 style="color: #502189"><i class="fa fa-handshake-o"></i>&nbsp;
                    Timesheet
                </h5>
            </div>
            <div class="col-lg-3">
                <i class="fa fa-spinner fa-spin" style="color: #502189;font-size: 20px;" 
                    *ngIf="global.checkProgressTimesheet==true"></i>
                <i class="fa fa-check" style="color: green;font-size: 20px;"
                    *ngIf="global.checkProgressTimesheet==false || global.checkProgressTimesheet==null" ></i>
            </div>
        </div>
        <div class="row mb-3 ms-3">
            <div class="col-lg-9">
                <h5 style="color: #502189"><i class="fa fa-shopping-cart"></i>&nbsp;
                    Purchase
                </h5>
            </div>
            <div class="col-lg-3">
                <i class="fa fa-spinner fa-spin" style="color: #502189;font-size: 20px;" 
                    *ngIf="global.checkProgressPurchase==true"></i>
                <i class="fa fa-check" style="color: green;font-size: 20px;"
                    *ngIf="global.checkProgressPurchase==false||global.checkProgressPurchase==null" ></i>
            </div>
        </div>
        <div class="row mb-3 ms-3">
            <div class="col-lg-9">
                <h5 style="color: #502189"><i class="fa fa-exchange"></i>&nbsp;
                    Transaction
                </h5>
            </div>
            <div class="col-lg-3">
                <i class="fa fa-spinner fa-spin" style="color: #502189;font-size: 20px;" 
                    *ngIf="global.checkProgressTransaction==true"></i>
                <i class="fa fa-check" style="color: green;font-size: 20px;"
                    *ngIf="global.checkProgressTransaction==false||global.checkProgressTransaction==null" ></i>
            </div>
        </div>
        <div class="row mb-3 ms-3">
            <div class="col-lg-9">
                <h5 style="color: #502189"><i class="fa fa-exchange"></i>&nbsp;
                    CSG
                </h5>
            </div>
            <div class="col-lg-3">
                <i class="fa fa-spinner fa-spin" style="color: #502189;font-size: 20px;" 
                    *ngIf="global.checkProgressCSG==true"></i>
                <i class="fa fa-check" style="color: green;font-size: 20px;"
                    *ngIf="global.checkProgressCSG==false||global.checkProgressCSG==null" ></i>
            </div>
        </div>
    </div>
</div>